/// <reference path="wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    /**
     * Namespace for utility functions.
     */
    let Utilities;
    (function (Utilities) {
        const LOG_CATEGORY = "WPT.Functions";
        const INPUT_DISABLED_CLASS = "wpt-input--disabled";
        const INPUT_SELECTOR = '.wpt-input__input';
        /**
         * Class holding generic functions. No dependencies to other WPT "modules".
         */
        class GenericFunctions {
            constructor() {
                this._log = null;
                this.initLogging = (core) => {
                    
                    this._log = core.Logging.getLogger(LOG_CATEGORY);
                };
                /**
                 * Function used to wait before logic continues.
                 * @param milliseconds number of milliseconds before the Promise resolves
                 * @returns a Promise that resolves after a given time
                 */
                this.sleep = (milliseconds) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.sleep()");
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("sleeping " + milliseconds + " ms");
                    }
                    return new Promise(resolve => window.setTimeout(resolve, milliseconds));
                };
                /**
                 * Function used to examine query string and deliver string array back.
                 * @returns string array of values with named keys in lower case
                 */
                this.examineQueryString = () => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.examineQueryString()");
                    }
                    let result = [];
                    let queryString = window.location.search;
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("looking at query string: " + queryString);
                    }
                    if (queryString.length > 1) {
                        let queryParts = queryString.substring(1).split('&');
                        let queryPartsLength = queryParts.length;
                        for (let i = 0; i < queryPartsLength; i++) {
                            let queryPart = queryParts[i];
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("looking at query part: " + queryPart);
                            }
                            if (queryPart.length > 0) {
                                let query = queryPart.split('=');
                                if (this._log !== null && this._log.isTraceEnabled()) {
                                    this._log.trace("number of query part splits: " + query.length);
                                }
                                if (query.length == 2) {
                                    let key = window.decodeURIComponent(query[0]).toLowerCase();
                                    let value = window.decodeURIComponent(query[1]);
                                    if (this._log !== null && this._log.isTraceEnabled()) {
                                        this._log.trace("adding key: " + key + ", with value: " + value);
                                    }
                                    result[key] = value;
                                }
                            }
                        }
                    }
                    return result;
                };
                /**
                 * Function used to change (or add) a specific parameter in the query string.
                 * @param key the name of the query string parameter
                 * @param value the value of the query string parameter
                 */
                this.changeQueryString = (key, value) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.changeQueryString()");
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("setting query string '" + key + "' to value: " + value);
                    }
                    let newUrl = window.location.origin + window.location.pathname;
                    let newSearch = '?';
                    let firstSet = false;
                    let valueChanged = false;
                    let queryString = window.location.search;
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("looking at query string: " + queryString);
                    }
                    let keyEqual = key + "=";
                    let startsWithKey = keyEqual.toLowerCase();
                    if (queryString.length > 1) {
                        let queryParts = queryString.substring(1).split('&');
                        let queryPartsLength = queryParts.length;
                        for (let i = 0; i < queryPartsLength; i++) {
                            let queryPart = queryParts[i];
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("looking at query part: " + queryPart);
                            }
                            if (queryPart.toLowerCase().startsWith(startsWithKey)) {
                                if (this._log !== null && this._log.isTraceEnabled()) {
                                    this._log.trace("found query string parameter, replacing value");
                                }
                                if (firstSet) {
                                    newSearch += '&';
                                }
                                else {
                                    firstSet = true;
                                }
                                newSearch += keyEqual + value;
                                valueChanged = true;
                            }
                            else if (queryPart.length > 0) {
                                // not the query string parameter to change, just keep it in the query string
                                if (firstSet) {
                                    newSearch += '&';
                                }
                                else {
                                    firstSet = true;
                                }
                                newSearch += queryPart;
                            }
                        }
                    }
                    if (!valueChanged) {
                        if (this._log !== null && this._log.isTraceEnabled()) {
                            this._log.trace("query string not found, adding value");
                        }
                        if (firstSet) {
                            newSearch += '&';
                        }
                        newSearch += keyEqual + value;
                    }
                    if (newSearch.length > 1) {
                        newUrl += newSearch;
                    }
                    newUrl += window.location.hash;
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("replacing path with: " + newUrl);
                    }
                    window.history.replaceState('Web Portal Toolkit', 'Web Portal Toolkit - Gateway', newUrl);
                };
                /**
                 * Function used to remove a specific parameter in the query string.
                 * @param key the name of the query string parameter
                 */
                this.removeQueryString = (key) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.removeQueryString()");
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("removing query string '" + key + "'");
                    }
                    let newUrl = window.location.origin + window.location.pathname;
                    let newSearch = '?';
                    let firstSet = false;
                    let queryString = window.location.search;
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("looking at query string: " + queryString);
                    }
                    let startsWithKey = key.toLowerCase() + "=";
                    if (queryString.length > 1) {
                        let queryParts = queryString.substring(1).split('&');
                        let queryPartsLength = queryParts.length;
                        for (let i = 0; i < queryPartsLength; i++) {
                            let queryPart = queryParts[i];
                            if (this._log !== null && this._log.isTraceEnabled()) {
                                this._log.trace("looking at query part: " + queryPart);
                            }
                            if (queryPart.toLowerCase().startsWith(startsWithKey)) {
                                if (this._log !== null && this._log.isTraceEnabled()) {
                                    this._log.trace("found query string parameter, removing");
                                }
                            }
                            else if (queryPart.length > 0) {
                                // not the query string parameter to remove, just keep it in the query string
                                if (firstSet) {
                                    newSearch += '&';
                                }
                                else {
                                    firstSet = true;
                                }
                                newSearch += queryPart;
                            }
                        }
                    }
                    if (newSearch.length > 1) {
                        newUrl += newSearch;
                    }
                    newUrl += window.location.hash;
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("replacing path with: " + newUrl);
                    }
                    window.history.replaceState('Web Portal Toolkit', 'Web Portal Toolkit - Gateway', newUrl);
                };
                /**
                 * Clears an input element.
                 * @param element the input element to clear
                 */
                this.clearInputElement = (element) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.clearInputElement()");
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("clearing input element: " + element.id);
                    }
                    element.value = "";
                };
                /**
                 * Clears an input element (and sets the focus).
                 * @param element the input element to clear and focus
                 */
                this.clearAndFocusInputElement = (element) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.clearAndFocusInputElement()");
                    }
                    this.clearInputElement(element);
                    element.focus();
                };
                /**
                 * Sets the ability (readonly or not) of the input.
                 * @param inputDiv the input DIV element to add/remove the CSS class
                 * @param ability the ability of the input (true = editable, false = readonly)
                 * @param element optional the actual input element (if omitted, element is selected based on CSS class)
                 */
                this.setInputAbility = (inputDiv, ability, element = null) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.setInputAbility()");
                    }
                    if (element == null) {
                        element = inputDiv.querySelector(INPUT_SELECTOR);
                    }
                    if (ability) {
                        inputDiv.classList.remove(INPUT_DISABLED_CLASS);
                        element.readOnly = false;
                    }
                    else {
                        inputDiv.classList.add(INPUT_DISABLED_CLASS);
                        element.readOnly = true;
                    }
                };
                /**
                 * Hides an element.
                 * @param element the element to hide
                 */
                this.hideElement = (element) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.hideElement()");
                    }
                    element.classList.add(WPTNamespace.HIDDEN_CLASS);
                };
                /**
                 * Shows an element.
                 * @param element the element to show
                 */
                this.showElement = (element) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.showElement()");
                    }
                    element.classList.remove(WPTNamespace.HIDDEN_CLASS);
                };
                /**
                 * Gets function by name. Can be used to dynamically call a constructor of a class.
                 * @param str name of the function (name of the class including namespaces)
                 * @returns the function if it was found
                 * @throws Error if the function is not found
                 */
                this.stringToFunction = (str) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.stringToFunction()");
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("looking for: " + str);
                    }
                    let arr = str.split(".");
                    let arrLength = arr.length;
                    let fn = (window || this);
                    let path = null;
                    for (let i = 0; i < arrLength; i++) {
                        let arrPart = arr[i];
                        if (this._log !== null && this._log.isTraceEnabled()) {
                            this._log.trace("looking at part: " + arrPart + (path != null ? (", in path: " + path) : ""));
                        }
                        fn = fn[arrPart];
                        if (fn == undefined) {
                            console.warn("failed to find: " + arrPart + (path != null ? (" in " + path) : ""));
                            throw new Error("path not found");
                        }
                        if (path == null) {
                            path = arrPart;
                        }
                        else {
                            path += "." + arrPart;
                        }
                    }
                    if (typeof fn !== "function") {
                        console.warn("failed to find function: " + str);
                        throw new Error("function not found");
                    }
                    return fn;
                };
                /*
                * Takes a dotted path and finds the object member with that address - null if missing
                */
                this.mapObject = (path, obj) => {
                    return path.split('.').reduce(function (prev, curr) {
                        return prev ? prev[curr] : null;
                    }, obj || self);
                };
                this.dateToTransportFormat = (date) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.dateToTransportFormat()");
                    }
                    let day = ('00' + date.getDate().toString()).slice(-2);
                    let month = ('00' + (date.getMonth() + 1).toString()).slice(-2);
                    return `${date.getFullYear().toString()}-${month}-${day}`;
                };
                this.dateNumberToTransportFormat = (dateMillisconds) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.dateNumberToTransportFormat()");
                    }
                    let date = new Date(dateMillisconds);
                    return this.dateToTransportFormat(date);
                };
                /**
                 * Gets the complete height (in pixel) for an element.
                 * @param element The element from which the height should be calculated
                 * @returns The height in pixel
                 */
                this.getCompleteElementHeight = (element) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.getCompleteElementHeight()");
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("element: " + element.id);
                    }
                    // start with offsetHeight (height of element including padding, but not margin)
                    let result = element.offsetHeight;
                    let marginHeight = this.getElementMarginHeight(element);
                    result += marginHeight;
                    return result;
                };
                this.getElementMarginHeight = (element) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.getElementMarginHeight()");
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("element: " + element.id);
                    }
                    let result = 0;
                    // get computed style in order to get the "real" margin values
                    let computedStyle = window.getComputedStyle(element);
                    // adding margin-top
                    let marginTop = computedStyle.marginTop;
                    if (marginTop != "none") {
                        // expecting margin-top set in pixels
                        result += parseInt(marginTop, 10);
                    }
                    // adding margin-bottom
                    let marginBottom = computedStyle.marginBottom;
                    if (marginBottom != "none") {
                        // expecting margin-bottom set in pixels
                        result += parseInt(marginBottom, 10);
                    }
                    return result;
                };
                this.getElementBorderHeight = (element) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.getElementBorderHeight()");
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("element: " + element.id);
                    }
                    let result = 0;
                    // get computed style in order to get the "real" border values
                    let computedStyle = window.getComputedStyle(element);
                    // adding border-top
                    let borderTop = computedStyle.borderTopWidth;
                    if (borderTop != "none") {
                        // expecting border-top set in pixels
                        result += parseInt(borderTop, 10);
                    }
                    // adding border-bottom
                    let borderBottom = computedStyle.borderBottomWidth;
                    if (borderBottom != "none") {
                        // expecting border-bottom set in pixels
                        result += parseInt(borderBottom, 10);
                    }
                    return result;
                };
                /**
                 * Gets the padding height (in pixel) for an element.
                 */
                this.getElementPaddingHeight = (element) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.getElementPaddingHeight()");
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("element: " + element.id);
                    }
                    let result = 0;
                    // get computed style in order to get the "real" padding values
                    let computedStyle = window.getComputedStyle(element);
                    // adding padding-top
                    let paddingTop = computedStyle.paddingTop;
                    if (paddingTop != "none") {
                        // expecting padding-top set in pixels
                        result += parseInt(paddingTop, 10);
                    }
                    // adding padding-bottom
                    let paddingBottom = computedStyle.paddingBottom;
                    if (paddingBottom != "none") {
                        // expecting padding-bottom set in pixels
                        result += parseInt(paddingBottom, 10);
                    }
                    return result;
                };
                /**
                 * Gets the complete width (in pixel) for an element.
                 * @param element The element from which the width should be calculated
                 * @returns The width in pixel
                 */
                this.getCompleteElementWidth = (element) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.getCompleteElementWidth()");
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("element: " + element.id);
                    }
                    // start with offsetWidth (width of element including padding, but not margin)
                    let result = element.offsetWidth;
                    let marginWidth = this.getElementMarginWidth(element);
                    result += marginWidth;
                    return result;
                };
                this.getElementMarginWidth = (element) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.getElementMarginWidth()");
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("element: " + element.id);
                    }
                    let result = 0;
                    // get computed style in order to get the "real" margin values
                    let computedStyle = window.getComputedStyle(element);
                    // adding margin-left
                    let marginLeft = computedStyle.marginLeft;
                    if (marginLeft != "none") {
                        // expecting margin-top set in pixels
                        result += parseInt(marginLeft, 10);
                    }
                    // adding margin-right
                    let marginRight = computedStyle.marginRight;
                    if (marginRight != "none") {
                        // expecting margin-bottom set in pixels
                        result += parseInt(marginRight, 10);
                    }
                    return result;
                };
                /**
                 * Gets the padding width (in pixel) for an element.
                 */
                this.getElementPaddingWidth = (element) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.getElementPaddingWidth()");
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("element: " + element.id);
                    }
                    let result = 0;
                    // get computed style in order to get the "real" padding values
                    let computedStyle = window.getComputedStyle(element);
                    // adding padding-left
                    let paddingLeft = computedStyle.paddingLeft;
                    if (paddingLeft != "none") {
                        // expecting padding-left set in pixels
                        result += parseInt(paddingLeft, 10);
                    }
                    // adding padding-right
                    let paddingRight = computedStyle.paddingRight;
                    if (paddingRight != "none") {
                        // expecting padding-right set in pixels
                        result += parseInt(paddingRight, 10);
                    }
                    return result;
                };
                this.getElementBorderWidth = (element) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.getElementBorderWidth()");
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("element: " + element.id);
                    }
                    let result = 0;
                    // get computed style in order to get the "real" border values
                    let computedStyle = window.getComputedStyle(element);
                    // adding border-left
                    let borderLeft = computedStyle.borderLeftWidth;
                    if (borderLeft != "none") {
                        // expecting border-left set in pixels
                        result += parseInt(borderLeft, 10);
                    }
                    // adding border-right
                    let borderRight = computedStyle.borderRightWidth;
                    if (borderRight != "none") {
                        // expecting border-right set in pixels
                        result += parseInt(borderRight, 10);
                    }
                    return result;
                };
                /**
                 * Encodes strings in a safe manner to transfer through HTTP calls. Need according handling for decoding.
                 * @param uriComponent the string to be safely encoded
                 * @returns the safely encoded string
                 */
                this.safeEncodeURIComponent = (uriComponent) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.safeEncodeURIComponent()");
                    }
                    let result = window.encodeURIComponent(uriComponent);
                    result = result.replace(/%(2f|5c)/gi, "%40$1%40");
                    return result;
                };
                this.getTimezoneCorrectedDateTime = (dateTime) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.getTimezoneCorrectedDateTime()");
                    }
                    let initialDate = new Date(dateTime);
                    let offset = initialDate.getTimezoneOffset();
                    let absOffset = Math.abs(offset);
                    let tzCorrection = (offset < 0 ? "+" : "-") + ("00" + Math.floor(absOffset / 60)).slice(-2) + ":" + ("00" + (absOffset % 60)).slice(-2);
                    let resultingDate = new Date(dateTime + tzCorrection);
                    return resultingDate;
                };
                this.safeEncodeHTMLContent = (sanitise) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.safeEncodeHTMLContent()");
                    }
                    // Escape a string for HTML interpolation.
                    if (sanitise === null)
                        return "";
                    else
                        return sanitise.replace(/[^\w. ]/gi, function (match) { return '&#' + match.charCodeAt(0) + ';'; });
                };
                /**
                 * Adds defaults for trigger events if setting is not specified.
                 * @param triggerEvents array of trigger events to add the defaults to
                 * @param eventTypes optional string array of event types (default is ['*'])
                 * @param sourceTypes optional string array of source types (default is ['*'])
                 * @param sourcePlaceholders optional string array of source placeholders (default is ['*'])
                 * @param eventIDs optional number array of event IDs (default is [])
                 */
                this.addDefaultsToTriggerEvents = (triggerEvents, eventTypes = ['*'], slots = ['*'], sourceTypes = ['*'], sourcePlaceholders = ['*'], eventIDs = []) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.addDefaultsToTriggerEvents()");
                    }
                    triggerEvents.forEach(trigger => {
                        if (!trigger.hasOwnProperty('EventTypes') || (trigger.EventTypes == null))
                            trigger.EventTypes = eventTypes;
                        if (!trigger.hasOwnProperty('Slots') || (trigger.Slots == null))
                            trigger.Slots = slots;
                        if (!trigger.hasOwnProperty('EventIDs') || (trigger.EventIDs == null))
                            trigger.EventIDs = eventIDs;
                        if (!trigger.hasOwnProperty('SourceTypes') || (trigger.SourceTypes == null))
                            trigger.SourceTypes = sourceTypes;
                        if (!trigger.hasOwnProperty('SourcePlaceholders') || (trigger.SourcePlaceholders == null))
                            trigger.SourcePlaceholders = sourcePlaceholders;
                    });
                };
                /**
                 * Checks if a trigger event matches the current navigation change context.
                 * @param trigger the trigger event to check
                 * @param context the navigation change context to check against
                 * @returns TRUE if trigger matches context, otherwise FALSE
                 */
                this.triggerEventMatches = (trigger, context) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.triggerEventMatches()");
                    }
                    // Match event
                    if ((trigger.EventTypes.indexOf(context.ActivationType) == -1) && (trigger.EventTypes.indexOf('*') == -1))
                        return false;
                    // TODO - do we need to check slots on more activation types?
                    if ((context.ActivationType == WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED) ||
                        (context.ActivationType == WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED) ||
                        (context.ActivationType == WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_SELECTED) ||
                        (context.ActivationType == WPTNamespace.Navigation.LayoutActivationType.WV_OBJECT_DESELECTED)) {
                        if (trigger.Slots.indexOf('*') == -1 && !trigger.Slots.some(slot => (context.Slots.indexOf(slot) > -1)))
                            return false;
                    }
                    if ((trigger.EventIDs.length > 0) && (trigger.EventIDs.indexOf(context.ActivationID) == -1))
                        return false;
                    let widget = context.ActivatingWidget;
                    if ((trigger.SourceTypes.indexOf('*') == -1) && (!widget || (trigger.SourceTypes.indexOf(widget.TypeName) == -1)))
                        return false;
                    if ((trigger.SourcePlaceholders.indexOf('*') == -1) && (!widget || (trigger.SourcePlaceholders.indexOf(widget.Id) == -1)))
                        return false;
                    // We only get here if the trigger has matched all the previous tests
                    return true;
                };
                /**
                 * Merges two objects into one (the second object will override the first object).
                 * @param obj1 Object into which {@link obj2} gets merged.
                 * @param obj2 Object which merges into {@link obj1}.
                 * @returns The merged object.
                 */
                this.mergeObjects = (obj1, obj2) => {
                    if (this._log !== null && this._log.isInfoEnabled()) {
                        this._log.info("GenericFunctions.mergeObjects()");
                    }
                    let result = JSON.parse(JSON.stringify(obj1));
                    if (typeof obj2 !== "object") {
                        result = obj2;
                    }
                    else {
                        for (let key in obj2) {
                            if (obj2.hasOwnProperty(key) && typeof obj1[key] !== "undefined") {
                                result[key] = this.mergeObjects(obj1[key], obj2[key]);
                            }
                            else {
                                result[key] = obj2[key];
                            }
                        }
                    }
                    if (this._log !== null && this._log.isTraceEnabled()) {
                        this._log.trace("returning: " + JSON.stringify(result));
                    }
                    return result;
                };
                
            }
            // Global unique ID, save running a bunch of static counters across all widgets/components
            get UniqueNumber() {
                GenericFunctions._iterator++;
                return GenericFunctions._iterator;
            }
            get UniqueTag() {
                GenericFunctions._iterator++;
                return GenericFunctions._iterator.toString();
            }
        }
        GenericFunctions._iterator = 0; // Holder for global iterator for unique IDs
        Utilities.GenericFunctions = GenericFunctions;
    })(Utilities = WPTNamespace.Utilities || (WPTNamespace.Utilities = {}));
})(WPTNamespace || (WPTNamespace = {}));
